// Invitation statuses
export const INVITATION_STATUSES = {
  PENDING: 'pending',
  ACCEPTED: 'accepted',
  EXPIRED: 'expired',
} as const

export type InvitationStatus = (typeof INVITATION_STATUSES)[keyof typeof INVITATION_STATUSES]

// User roles
export const USER_ROLES = {
  SUPER: 'super',
  ADMIN: 'admin',
  EDITOR: 'editor',
  VIEWER: 'viewer',
} as const

export type UserRole = (typeof USER_ROLES)[keyof typeof USER_ROLES]

// Invitation interface
export interface Invitation {
  id: number
  email: string
  role: UserRole
  status: InvitationStatus
  expires_at: string
  created_at: string
  updated_at?: string
}

// Toast notification durations
export const TOAST_DURATIONS = {
  SUCCESS: 3000,
  ERROR: 5000,
  WARNING: 4000,
  INFO: 3000,
} as const

// Invitation validation
export const INVITATION_CONSTRAINTS = {
  MAX_EMAIL_LENGTH: 255,
  MIN_EMAIL_LENGTH: 5,
  EXPIRY_DAYS: 7,
} as const

// Default empty states
export const EMPTY_STATES = {
  INVITATIONS: {
    title: 'No invitations found',
    description: 'Invitations you send will appear here for management',
  },
} as const
